import { format, differenceInMilliseconds, parse } from 'date-fns';
import * as utils from '../../utils/utils.js';

export default class Lobbyquestion {
    constructor($scope, $interval, watchService) {
        this.questionnaireFunctionalityComplete = false;
        this.$interval = $interval;
        this.watchService = watchService;
        this.event = this.watchService.event;
        this.quarantine = false;
        this.lsNumSentVar = 'vcl-numSent-' + this.event.accessKey;
        this.lslastSentVar = 'vcl-lastSent-' + this.event.accessKey;
        this.userEmail = '';
        this.setCurrentUserEmail();
        this.siteSettings = siteSettings;

        // eslint-disable-next-line no-unused-vars
        $scope.$watch('ctrl.message', function(newValue, oldValue) {
            if (newValue !== undefined && newValue !== null) {
                let noCR = utils.replaceNewline(newValue, '');
                $scope.ctrl.message = noCR.substring(0, 379);
            }
        });
    }

    $onInit() {
        this.initQuestionnaireFunctionality();
        this.$interval(() => {
            this.releaseQuarantine();
        }, 60000);
    }

    initQuestionnaireFunctionality() {
        let lastSent = localStorage.getItem(this.lslastSentVar);
        if (lastSent === undefined || lastSent === null || lastSent === '')
            localStorage.setItem(this.lslastSentVar, format(new Date(1900, 1), 'T')); // Store as ms as the decoding of localStorage date has proven tricky

        let numSent = localStorage.getItem(this.lsNumSentVar);
        if (numSent === undefined || numSent === null || numSent === '')
            localStorage.setItem(this.lsNumSentVar, 0);

        this.quarantineCheck();

        this.questionnaireFunctionalityComplete = true;
    }

    setCurrentUserEmail() {
        if (this.watchService.user !== null) this.userEmail = this.watchService.user._au;

        if (this.userEmail !== null && this.userEmail.length > 0) this.anon = false;
        else this.anon = true;
    }

    enterName() {
        window.location.href = utils.getSignInUrl(false, null, this.event.accessKey);
    }

    releaseQuarantine() {
        let lastPost = parse(localStorage.getItem(this.lslastSentVar), 'T', new Date()); // make sure parse with same format (ms) stored..
        let msSince = differenceInMilliseconds(new Date(), lastPost);
        if (msSince > 300000) {
            this.quarantine = false;
            localStorage.setItem(this.lsNumSentVar, 0);
        }
    }

    quarantineCheck() {
        if (localStorage.getItem(this.lsNumSentVar) > 2) {
            this.quarantine = true;
        }
    }

    submit() {
        if (this.message === undefined || this.message === null || this.message === '') return;

        let reqUrl = '/events/postquestion';
        let cur = this;

        let selectedName =
            this.anon ||
            this.watchService.user === null ||
            localStorage.getItem('vcl-name') === undefined
                ? ''
                : utils.getUserDisplayNameWithCompany(this.watchService.user);
        let selectedEmail =
            this.anon ||
            this.watchService.user === null ||
            localStorage.getItem('vcl-email') === undefined
                ? ''
                : localStorage.getItem('vcl-email');

        fetch(reqUrl, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            method: 'POST',
            body:
                'displayName=' +
                selectedName +
                '&email=' +
                selectedEmail +
                '&questionText=' +
                cur.message +
                '&accessKey=' +
                cur.event.accessKey +
                '&askAnonymously=' +
                cur.anon,
            credentials: 'include'
        }).then(function(response) {
            cur.message = null;

            localStorage.setItem(cur.lslastSentVar, format(new Date(), 'T'));
            localStorage.setItem(
                cur.lsNumSentVar,
                parseInt(localStorage.getItem(cur.lsNumSentVar)) + 1
            );

            // Update placeholder temporarily to acknowledge the user action...
            // Anything but response.ok indicates that the message was not added
            cur.event.questionnaireText = response.ok
                ? cur.event.questionnaireConfirmationText
                : 'There was a problem posting your text. If this problem persists, please reload the page and try again.';

            cur.quarantineCheck();
        });
    }
}
